export default __webpack_public_path__ + "static/media/TF_19.5bc75f0e.png";